import { useEffect } from "react";
import { getDomainConfig } from "../config/domains";

const ClarityAnalytics = () => {
  useEffect(() => {
    const domainConfig = getDomainConfig();
    const clarityId = domainConfig.clarityId;

    // Перевірка чи в Development
    const isDevelopment = () => {
      const hostname = window.location.hostname;
      const isLocalhost =
        hostname === "localhost" ||
        hostname === "127.0.0.1" ||
        hostname === "[::1]" ||
        hostname === "" ||
        hostname.startsWith("192.168.") ||
        hostname.startsWith("10.");

      const port = window.location.port;
      const isDevServer =
        port === "5173" ||
        port === "5174" ||
        port === "5175" ||
        port === "5176" ||
        port === "3000" ||
        port === "8080";

      return isLocalhost || isDevServer;
    };

    // Не завантажувати в Development
    if (isDevelopment()) {
      return;
    }

    // Якщо немає Clarity ID для цього домену
    if (!clarityId) {
      console.warn(`⚠️ Kein Clarity ID für Domain: ${domainConfig.domain}`);
      return;
    }

    // Перевірити чи вже завантажено
    if ((window as any).clarity) {
      return;
    }

    // Завантажити Clarity
    const loadClarity = () => {
      const w = window as any;
      const d = document;

      w.clarity =
        w.clarity ||
        function (...args: any[]) {
          (w.clarity.q = w.clarity.q || []).push(args);
        };

      const script = d.createElement("script");
      script.async = true;
      script.src = `https://www.clarity.ms/tag/${clarityId}`;

      const firstScript = d.getElementsByTagName("script")[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      }
    };

    loadClarity();
  }, []);

  return null;
};

export default ClarityAnalytics;
